import { createActionGroup, emptyProps, props } from '@ngrx/store';

export interface RecentlyViewedItem {
  id: string;
  name: string;
  provider: string;
  domain?: string;
  platform?: string;
}

export const UiActions = createActionGroup({
  source: 'UI',
  events: {
    'Set Theme': props<{ theme: 'light' | 'dark' | 'slb' }>(),
    'Set Tela Visibility': props<{ telaVisibility: 'none' | 'catalog' | 'all' }>(),
    'Set Domain Panel': props<{ domainPanel: 'Subsurface' | 'WellConstruction' | 'Production' | 'Sustainability' | 'DataManagement' | 'AI' }>(),
    'Set Dark Variant': props<{ variant: '1' | '2' }>(),
    'Set Search Enabled': props<{ enabled: boolean }>(),
    // Session-only: backend team should replace with HTTP effect (POST /users/search-history)
    'Add Recent Search': props<{ query: string }>(),
    'Remove Recent Search': props<{ query: string }>(),
    'Clear Recent Searches': emptyProps(),
    'Add Recently Viewed': props<{ product: RecentlyViewedItem }>(),
    'Clear Recently Viewed': emptyProps(),
    'Set Hero Variant': props<{ variant: 'seismic' | 'network' | 'tela' | 'cube' }>(),
    'Set Pricing Enable Workflow': props<{ enabled: boolean }>(),
    'Set Show Ea Products': props<{ enabled: boolean }>(),
    'Set Show Unavailable Button': props<{ enabled: boolean }>(),
  },
});
